import React, { useCallback, useEffect, useState } from 'react';
import './style.scoped.css';
import Loading from 'src/components/Loading';
import homeStore, { HomeStore } from 'src/stores/HomeStore';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import Dropdown from '../../components/Dropdown';
import UserInfoService from '../../utils/UserInfoService';
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import { CONSTANT } from '../../constants';
import PopupService from '../../utils/PopupService';
import i18n from '../../lang/i18n';
import InfoIcon from '../../assets/info_icon.svg';
import { showContact } from '../../utils';

const loadingComponent = <Loading type={'small'} />;
interface PaymentEachObserverProps {
  store?: HomeStore;
}

const mbAccountList = ['Tài khoản 1', 'Tài khoản 2'];
const paymentTypeList = ['Đóng phí định kỳ', 'Đóng phí Top-up', 'Đóng phí cho Hồ sơ yêu cầu bảo hiểm'];
const idInformationList = ['Chứng minh nhân dân', 'Căn cước công dân', 'Hộ chiếu', 'Chứng minh thư quân đội',
  'Giấy khai sinh', 'Giấy phép lái xe'];

const PaymentEachObserver = observer(({ store }: PaymentEachObserverProps) => {
  const { t } = useTranslation();

  const [listBankAccNo] = useState(mbAccountList.map(account => {
    return { value: account, label: account }
  }));
  const [bankAccNo, setBankAccNo] = useState(listBankAccNo[0]);

  const [listPaymentType] = useState(paymentTypeList.map(payment => {
    return { value: payment, label: payment }
  }));
  const [paymentType, setPaymentType] = useState(listPaymentType[0]);

  const [listIdInformation] = useState(idInformationList.map(information => {
    return { value: information, label: information }
  }));
  const [idInformation, setIdInformation] = useState(listIdInformation[0]);

  const [checkRadio, setCheckRadio] = useState<number>(1);
  const [periodicPolicyNumber, setPeriodicPolicyNumber] = useState<string>("");
  const [errPeriodicPolicyNumber, setErrPeriodicPolicyNumber] = useState<string>();
  const [topUpPolicyNumber, setTopUpPolicyNumber] = useState<string>("");
  const [errTopUpPolicyNumber, setErrTopUpPolicyNumber] = useState<string>();

  useEffect(() => {
    // let mbAccountList = UserInfoService.getUserInfo()?.mbAccountList;
    // let mbAccountDefault = UserInfoService.getUserInfo()?.mbAccountDefault;
  }, []);

  const _handleSelectTabPayFees = (param)=> {
    setCheckRadio(param);
  }

  const _handleChangePeriodicPolicyNumber = useCallback((e) => {
    setPeriodicPolicyNumber(e.target.value.toUpperCase());
    setErrPeriodicPolicyNumber(null);
  }, []);

  const _handleBlurPeriodicPolicyNumber = useCallback((e) => {
    let value = e.target.value?.trim().toUpperCase() || "";
    setPeriodicPolicyNumber(value);
  }, []);

  const _handleSubmit = async () => {

  };

  return (
    <div className="roundContent">
      <div className="pay-extra-fee">
        <div className="cardItemNoPadding">
          <div className="">
            <div className='labelText mb-2'>{t('Thông tin thanh toán')}</div>
            <Dropdown
              defaultValue={bankAccNo}
              listValue={listBankAccNo}
              onChange={(value) => setBankAccNo(value)}
              isSearchable={false}
            />
          </div>
          <div className="pt-5">
            <div className='labelText mb-2'>{t('Loại đóng phí')}</div>
            <Dropdown
              defaultValue={paymentType}
              listValue={listPaymentType}
              onChange={(value) => setPaymentType(value)}
              isSearchable={false}
            />
          </div>
          <div className="pt-5">
            <div className='labelText'>{t('Loại thông tin truy vấn')}</div>
            <div className="grid grid-cols-2 px-4 pt-2">
              <div className="flex items-center">
                <input
                  type="radio"
                  name="radio"
                  id="identification_id"
                  checked={checkRadio == 1}
                  onChange={()=>_handleSelectTabPayFees(1) }
                />
                <label
                  className="flex items-center cursor-pointer pl-2"
                  htmlFor="identification_id"

                >
                  {' '}
                  {t('Giấy tờ tùy thân')}
                </label>
              </div>
              <div className="flex items-center">
                <input
                  type="radio"
                  name="radio"
                  id="insuranceContract"
                  checked={checkRadio == 2}
                  onChange={()=>_handleSelectTabPayFees(2) }
                />
                <label
                  className="flex items-center cursor-pointer pl-2"
                  htmlFor="insuranceContract"
                >
                  {' '}
                  {t('Hợp đồng BH')}
                </label>
              </div>
            </div>
          </div>
          {checkRadio == 1 ? <>
              <div className="pt-5">
                <div className='labelText mb-2'>{t('Loại giấy tờ tùy thân')}</div>
                <Dropdown
                  defaultValue={idInformation}
                  listValue={listIdInformation}
                  onChange={(value) => setIdInformation(value)}
                  isSearchable={false}
                />
              </div>
              <div className="pt-5">
                <TextInput
                  label={t('identity_card_number')}
                  placeholder={''}
                  value={UserInfoService.getUserInfo()?.idCardNo || ''}
                  useDisabledStyle={true}
                  disabled={false}
                />
              </div>
            </>
            :
            <div className="pt-5">
              <TextInput
                label={t('policy_number')}
                placeholder={t('hint_insurance_policy_number')}
                value={periodicPolicyNumber}
                onChange={_handleChangePeriodicPolicyNumber}
                error={!!errPeriodicPolicyNumber}
                helperText={errPeriodicPolicyNumber}
                onBlur={_handleBlurPeriodicPolicyNumber}
              />
            </div>
          }
          <div className="pb-6 pt-5">
            <Button
              text={t('Tiếp theo')}
              extraClassName="w-full"
              onClick={_handleSubmit}
            />
          </div>
          <div className="bg-surface px-4 pt-4 pb-4 mt-4 border-b border-line">
            <div className="text-base font-bold text-onSurface">
              {`${t('Danh sách hồ sơ đã lưu')}`}
            </div>
          </div>
          <div className="bg-surface px-4 pt-4 pb-4 mb-8">
            <div className="mb-5">
              <div className="pb-4">
                List danh dach
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const PaymentEach = () => <PaymentEachObserver store={homeStore} />;
export default PaymentEach;
